import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Space, Select, Button, Form } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { APPOINTMENT_STATUSES } from 'constants/appointments';
import { PLAN_TYPES } from 'constants/profile';

import { FormFilters, IFiltersProps } from './types';
import { StyledFilter } from './styled';

const defaultValues = {
  name: '',
  type: '',
  status: ''
};

const Filters: FC<IFiltersProps> = ({ onSubmit, initialValues }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<FormFilters>();

  const onFinish = (values: FormFilters) => {
    onSubmit(values);
  };

  return (
    <StyledFilter>
      <Form form={form} initialValues={initialValues} onFinish={onFinish}>
        <Space style={{ marginBottom: 24 }} size={8}>
          <Form.Item name="name">
            <Input
              placeholder={t('filter.search')}
              prefix={<SearchOutlined />}
              size="large"
              style={{ width: 200 }}
            />
          </Form.Item>
          <Form.Item name="type">
            <Select
              size="large"
              placeholder={t('filter.type')}
              style={{ width: 200 }}
              options={PLAN_TYPES.map(item => ({
                value: `${item.value}`,
                label: t(`appointments.${item.label}`)
              }))}
            />
          </Form.Item>
          <Form.Item name="status">
            <Select
              size="large"
              placeholder="Status"
              style={{ width: 200 }}
              options={Object.entries(APPOINTMENT_STATUSES).map(
                ([key, value]) => ({
                  value: `${value}`,
                  label: t(`appointments.${key}`)
                })
              )}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" size="large" onClick={form.submit}>
              {t('appointments.apply')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              size="large"
              onClick={() => {
                form.setFieldsValue({
                  name: undefined,
                  type: undefined,
                  status: undefined
                });
                onSubmit({ ...defaultValues });
              }}
            >
              {t('appointments.reset')}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </StyledFilter>
  );
};

export default memo(Filters);
